export * from '@primeuix/themes/aura/speeddial';
export { default } from '@primeuix/themes/aura/speeddial';
